// core version + navigation, pagination modules:

import Swiper, {Navigation, Pagination} from 'swiper';
// import Swiper and modules styles
Swiper.use([Navigation]);
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.scss';
import Vue from "vue";

const $ = window.jQuery;
const $window = window.$window || $(window);
export function Homepage() {
    $(document).ready(function () {
        const heroSectionTabs = new Swiper('#tabsWrapper', {
            spaceBetween: 0,
            slidesPerView: 'auto',
            speed: 1000,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
        })
        const swiper = new Swiper('#phoenixAllInOneConcept', {
            spaceBetween: 15,
            slidesPerView: 1.2,
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            speed: 1000,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            breakpoints: {
                // when window width is >= 320px
                991: {
                    slidesPerView: 2.5,
                    spaceBetween: 20
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    allowTouchMove: false
                }
            }
        })
        const swiper2 = new Swiper('#phoenixAllInOneConcept2', {
            spaceBetween: 10,
            slidesPerView: 1.2,
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            speed: 1000,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            breakpoints: {
                // when window width is >= 320px
                991: {
                    slidesPerView: 2.5,
                    spaceBetween: 20
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 63,
                    allowTouchMove: false
                }
            }
        })
        const swiper3 = new Swiper('#all_in_one_advantages', {
            spaceBetween: 10,
            slidesPerView: 1,
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: '#next',
                prevEl: '#prev',
            },
            speed: 1000,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            breakpoints: {
                // when window width is >= 320px
                570: {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                991: {
                    slidesPerView: 3,
                    spaceBetween: 15
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                }
            }
        })
        const useFullLinks = new Swiper('#usefull-links-slider', {
            spaceBetween: 12,
            slidesPerView: 'auto',
            speed: 1000,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
        })
        const activeJobsSection = $('#job-listing')
        if (!activeJobsSection) return false
        const url = activeJobsSection.data('jobsurl')
        if (!url) return false
        const activeJobSectionHomepage = new Vue({
            el: `#job-listing`,
            data() {
                return {
                    loading: true,
                }
            },
            mounted() {
                const $that = this
                let filters = Array.prototype.slice.call(document.querySelectorAll('input[name=array_filter]'))
                if (filters) {
                    filters = filters.map(el => +el.value)
                }
                $.ajax({
                    method: 'POST',
                    url: ajax_object.ajaxurl,
                    data: {
                        action: 'getTalentifyJoblist',
                        nonce: ajax_object.nonce,
                        data: {
                            url: url,
                        }
                    },
                    success: function (data) {
                        if (!data) return false
                        const parser = new DOMParser();
                        let wrapper = $('#active_jobs_section__wrapper')
                        const parsedHtml = parser.parseFromString(data, "text/html")
                        let aTags = parsedHtml.getElementsByTagName("a")
                        let pTag = `<p class="text-p mb-6">Ukoliko ste zainteresirani i želite postati dio našeg tima, pošaljite nam svoj životopis putem linka za prijavu unutar oglasa.</p>`
                        let item = '<article class="col-span-4 p-10 bg-white border border-phoenix-gray-800"> </article>'
                        if (aTags && Array.from(aTags).length) {
                            Array.from(aTags).forEach((el, index) => {
                                $(el).find('.name').after(pTag)
                                let href = $(el).attr('href')
                                item = `<article id="slide_${index}" class="singleJob swiper-slide bg-white border border-phoenix-gray-800">
                                <div class="p-10">                             
                                    <div class="mb-6">
                                         ${new XMLSerializer().serializeToString(el)}                                   
                                    </div>
                                    <div class="btn-wrap">
                                     <a href="${href}" target="_blank" class="btn">Prijavi se na oglas</a>
                                    </div>
                                </div>
                            </article>`
                                if (filters && filters.length) {
                                    if (filters.includes(index + 1)) {
                                        $(wrapper).append(item)
                                    }
                                } else {
                                    if (index < 3) {
                                        $(wrapper).append(item)
                                    }
                                }
                            })
                        }
                        const swiper3 = new Swiper('#active_jobs_section__wrapper__swiper', {
                            spaceBetween: 12,
                            slidesPerView: 1.2,
                            speed: 1000,
                            centerInsufficientSlides: true,
                            breakpoints: {
                                860: {
                                    slidesPerView: 2.5,
                                    spaceBetween: 15
                                },
                                1200: {
                                    slidesPerView: 3,
                                    spaceBetween: 20,
                                }
                            }
                        })
                        $that.loading = false
                    }
                })
            }
        })
    });
}
Homepage()
